<template lang="pug">
.templates-managerment
  h1 模板管理
  .templates
    .template(v-for='t in templates')
      .icon
        img(:src='get_icon_url(t.type)')
      .name {{t.desc || t.name}}
      .filename {{t.template}}
      .last_update {{t.last_update}}
      .action-buttons
        i.icon.download(@click='download(t)')
        file-upload(:ref='"uploader-"+t.name', name='template', @input='(files)=>filesChanged(t, files)', @input-file='inputFile', :post-action='action_path(t)', :accept='accept(t)')
          i.icon.upload.cloud

</template>

<script>
import FileUpload from 'vue-upload-component'
import LogoExcel from '../../assets/images/excel_logo.svg'
import LogoWord from '../../assets/images/word_logo.svg'
import config from '../../config'

export default {
  components: {
    FileUpload,
  },
  mounted() {
    this.get_list()
  },
  data() {
    return {
      templates: [],
    }
  },
  methods: {
    get_icon_url(type) {
      if (type === 'xlsx') return LogoExcel
      return LogoWord
    },
    get_list() {
      this.$http.get('system/templates').then(r => {
        this.templates = r.body
      })
    },
    download(template) {
      this.$templater.download_template(template.name, template.desc)
    },
    action_path(template) {
      return `${config.api_root_url}system/templates/upload/${template.name}`
    },
    accept(template) {
      if (template.type === 'xlsx')
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (template.type === 'docx')
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    },
    filesChanged(template, files) {
      const name = template.name
      if (files && files.length) {
        const uploader = (this.$refs[`uploader-${name}`] || [])[0]
        if (uploader && !uploader.active) {
          template.uploading = true
          uploader.active = true
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log('response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          const status = newFile.xhr.status
          console.log('status', status)
          if (status === 200) {
            this.$message({
              type: 'success',
              message: '模板上传成功!',
            })
          } else {
            this.$message({
              type: 'error',
              message: `模板上传失败! Code:${status}`,
            })
          }
        }
      }
    },
  },
}
</script>

<style lang="less">
.templates-managerment {
  .templates {
    .template {
      padding: 1em;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin: 10px;
      display: inline-block;
      text-align: center;
      min-width: 100px;

      .icon img {
        width: 40px;
        height: 40px;
        margin: 5px;
      }
      .name {
        font-weight: bold;
        line-height: 1.2em;
      }
      .filename {
        line-height: 1em;
        opacity: 0.8;
        font-size: 0.8em;
      }
      .action-buttons {
        margin: 10px 5px 0 5px;
        padding: 0;

        .file-uploads {
          overflow: inherit !important;
        }

        i {
          opacity: 0.4;
          margin: 0 5px;
          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// TemplatesManagement.vue?28f19246